// Анимация линий на SVG-карте
itsoftApp.createModule("mapLines", function() {

    function linesAnimation() {
        var maxTrack = $(".line-track").length,
            min = 1,
            nextAnimation = Math.floor(Math.random() * (maxTrack - min)) + min;

        if (!$("#tr" + nextAnimation).hasClass("animate")) {
            $("#tr" + nextAnimation).addClass("animate");

            setTimeout(function() {
                $("#tr" + nextAnimation).removeClass("animate");
            }, 6000);
        }

    }

    linesAnimation();
    setInterval(function() {
        linesAnimation();
    }, 1500);

});
